//export { default as Example } from './modules/Example';

export { default as Accordion } from './modules/Accordion';
export { default as Blockquote } from './modules/Blockquote';
export { default as Carousel } from './modules/Carousel';
export { default as CookieConsent } from './modules/CookieConsent';
export { default as CopyLink } from './modules/CopyLink';
export { default as DarkHeader } from './modules/DarkHeader';
export { default as Explore } from './modules/Explore';
export { default as Filter } from './modules/Filter';
export { default as Gallery } from './modules/Gallery';
export { default as HeroWords } from './modules/HeroWords';
export { default as Load } from './modules/Load';
export { default as Loadmore } from './modules/Loadmore';
export { default as Map } from './modules/Map';
export { default as Menu } from './modules/Menu';
export { default as NavSelect } from './modules/NavSelect';
export { default as Player } from './modules/Player';
export { default as PlayerCta } from './modules/PlayerCta';
export { default as Process } from './modules/Process';
export { default as ProjectAnchors } from './modules/ProjectAnchors';
export { default as SectorAnchors } from './modules/SectorAnchors';
export { default as Scroll } from './modules/Scroll';
export { default as Timeline } from './modules/Timeline';
export { default as VideoInline } from './modules/VideoInline';
